// extracted by mini-css-extract-plugin
module.exports = {"legalBody":"DisplayLegalModal_legalBody__fIZYR"};